import { useGetOpenChangeTariffPopup } from '@entities/tariff/model';
import { IWidgetCard, IWidgetCategoriesList } from '@entities/widget-card/model/types';
import { useAddFreeWidget, useGetWidgetsListQuery } from '@entities/widget-shop/api/hooks';

import { useWidgetModals } from './useWidgetModals';

type TDetailsActionPayload = {
    isWidgetFree: boolean;
    widgetId?: IWidgetCard['id'];
    availableActionType?: IWidgetCard['availableActionType'];
    status?: IWidgetCard['status'];
    notMyCompany?: IWidgetCategoriesList['context']['notMyCompany'];
};

export const useWidgetModalFlow = (fromPage: boolean) => {
    const { data } = useGetWidgetsListQuery({ enabled: fromPage });
    const { handleAddFreeWidget } = useAddFreeWidget();
    const openChangeTariffPopupMutation = useGetOpenChangeTariffPopup();
    const { openOnlyAdmin, openPayment } = useWidgetModals();

    const handleDetailsAction = ({
        widgetId,
        isWidgetFree,
        availableActionType,
        notMyCompany,
    }: TDetailsActionPayload) => {
        if (!widgetId || availableActionType === 'none') return;

        if (isWidgetFree && availableActionType !== 'upgrade_tariff') {
            handleAddFreeWidget(widgetId, notMyCompany ?? false);
            return;
        }

        if (!isWidgetFree && data?.context?.notMyCompany) {
            openOnlyAdmin(widgetId);
            return;
        }

        if (availableActionType === 'upgrade_tariff') {
            openChangeTariffPopupMutation.mutate({
                widgetId,
                notMyCompany: notMyCompany ?? false,
            });
            return;
        }

        openPayment(widgetId);
    };

    return {
        handleDetailsAction,
    };
};
